"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));
var _async = _interopRequireDefault(require("react-select/async"));
var _react2 = require("@chakra-ui/react");
var _xCircle = _interopRequireDefault(require("@spothero/icons/x-circle"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var AutoSuggestSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    getOptions = _ref.getOptions,
    onChange = _ref.onChange,
    iconSrc = _ref.iconSrc,
    placeholder = _ref.placeholder,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue;
  var _useTheme = (0, _react2.useTheme)(),
    colors = _useTheme.colors,
    fontSizes = _useTheme.fontSizes,
    sizes = _useTheme.sizes;
  var handleChange = function handleChange(selectedOption) {
    onChange(selectedOption);
  };
  var icon = function icon() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transparent';
    return {
      alignItems: 'center',
      display: 'flex',
      ':before': {
        backgroundColor: color,
        content: '" "',
        display: 'block',
        marginRight: sizes['3'],
        height: sizes['4'],
        width: sizes['5'],
        mask: "url(".concat(iconSrc, ") no-repeat 50% 50%"),
        maskSize: 'contain'
      }
    };
  };
  var baseText = {
    fontSize: fontSizes.base,
    color: colors.black
  };

  /** React Select doesn't use Chakra but it does use Emotion so it's not too difficult to use values from our Chakra theme. Here is the documentation for React Select styling: https://react-select.com/styles  */
  var customStyles = {
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), baseText);
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200'],
        borderWidth: '1px',
        boxShadow: 'none',
        '&:hover': {
          borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200']
        }
      });
    },
    input: function input(provided, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, provided), baseText), {}, {
        padding: sizes['2'],
        backgroundColor: state.isDisabled ? colors.gray['200'] : 'transparent'
      }, iconSrc && icon(colors.gray['600']));
    },
    placeholder: function placeholder(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: sizes['2'],
        fontSize: fontSizes.base,
        color: colors.gray['600']
      }, iconSrc && icon());
    },
    singleValue: function singleValue(provided) {
      return _objectSpread(_objectSpread(_objectSpread({}, provided), baseText), {}, {
        padding: sizes['2']
      }, iconSrc && icon());
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        backgroundColor: state.isSelected ? colors.gray['200'] : state.isFocused ? colors.gray['50'] : 'transparent',
        color: colors.black
      });
    },
    clearIndicator: function clearIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: colors.gray['600']
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: colors.gray['600']
      });
    }
  };
  var clearIndicatorStyles = {
    width: sizes['5'],
    display: 'flex',
    marginRight: sizes['3'],
    color: colors.gray['600'],
    cursor: 'pointer'
  };

  /** React Select allows you to override the clear indicator with your own custom component: https://react-select.com/components */
  var ClearIndicator = function ClearIndicator(_ref2) {
    var innerRef = _ref2.innerRef,
      innerProps = _ref2.innerProps;
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      style: clearIndicatorStyles,
      ref: innerRef
    }, innerProps), /*#__PURE__*/_react["default"].createElement(_xCircle["default"], null));
  };
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    errorMessage: errorMessage,
    isRequired: isRequired,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/_react["default"].createElement(_async["default"], {
    closeMenuOnSelect: true,
    isClearable: true,
    cacheOptions: true,
    components: {
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      ClearIndicator: ClearIndicator
    },
    openMenuOnClick: false,
    loadOptions: getOptions,
    onChange: handleChange,
    isDisabled: isDisabled,
    id: id,
    placeholder: placeholder,
    defaultValue: defaultValue,
    styles: customStyles,
    ref: ref
  }));
});
var _default = exports["default"] = AutoSuggestSelect;